import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { switchMap, catchError } from 'rxjs/operators';
import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { ApiService } from '../services/api.service';
import { AuthenticationService } from "../services/index";
import { REST_API_REQUEST_CALL_URL } from './rest-api-request-url';

@Injectable()
export class MyHttpInterceptor implements HttpInterceptor {
  private apiService: ApiService;
  private authService : AuthenticationService;

  constructor(injector: Injector) {
    setTimeout(() => {
      this.apiService = injector.get(ApiService);
      this.authService = injector.get(AuthenticationService);
    });
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url == REST_API_REQUEST_CALL_URL.TOKEN_URL) {
      return next.handle(req).pipe(
        catchError((err, caught) => {
          if (err instanceof HttpErrorResponse && err.status === 400 && req.url == REST_API_REQUEST_CALL_URL.TOKEN_URL) {
            this.authService.logout();
            return next.handle(req);
          }
  
          throw caught;
        })
      )
    }

    return next.handle(req).pipe(
      switchMap(res => {
        if (res['body'] && res['body']['errorCode'] != null) {
          if ((res['body']['errorCode'] == '204' || res['body']['errorCode'] == '201')) {
            return this.apiService.refreshToken().pipe(
              switchMap(res => {
                sessionStorage.setItem('_vcd', res);
                req = req.clone({  // 6
                  setHeaders: {
                    'Authorization': `Bearer ${res}`
                  }
                });
                return next.handle(req);
              }));
          }
        }

        return new BehaviorSubject<HttpEvent<any>>(res).asObservable();
      }),
      catchError((err, caught) => {
        if (err instanceof HttpErrorResponse && err.status === 401) {
          return this.apiService.refreshToken().pipe(
            switchMap(res => {
              sessionStorage.setItem('_vcd', res);
              req = req.clone({  // 6
                setHeaders: {
                  'Authorization': `Bearer ${res}`
                }
              });
              return next.handle(req);
            }));
        }

        throw caught;
      })
    )
  }
}


// WEBPACK FOOTER //
// ./src/app/utils/http.interceptor.ts